import { createFilesFormData } from "@Front/Api/BaseApiServiceFactory/helpers/formDataRequestHelpers";

export interface DownloadMultipleFilesPayload {
	file_uids: string[];
	include_anchors: boolean;
	folder_number?: string;
	folder_name?: string;
}

export interface DownloadAggregatedCertificatePayload {
	document_uids: string[];
	folder_uid: string;
}

export function buildDownloadMultipleFilesPayload(
	fileUids: string[],
	includeAnchors: boolean,
	folderNumber?: string,
	folderName?: string,
): DownloadMultipleFilesPayload {
	return {
		file_uids: fileUids,
		include_anchors: includeAnchors,
		folder_number: folderNumber,
		folder_name: folderName,
	};
}

export function buildDownloadAggregatedCertificatePayload(
	documentUids: string[],
	folderUid: string,
): DownloadAggregatedCertificatePayload {
	return {
		document_uids: documentUids,
		folder_uid: folderUid,
	};
}

export function createSendToRecipientFormData(recipientUid: string, folderUid: string, files: File[]): FormData {
	const formData = createFilesFormData(files);
	formData.append("recipientUid", recipientUid);
	formData.append("folderUid", folderUid);
	return formData;
}
